import { Helmet } from "react-helmet";
import Hero from "../home/Hero";
import WhoWeAre from "../home/WhoWeAre";
import HowItWorks from "../home/HowItWorks";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>GPS Finvest - Home</title>
        <meta
          name="description"
          content="Welcome to GPS Finvest. Explore trusted financial solutions including loans, investments, and advisory services."
        />
      </Helmet>

      <Hero />
      <WhoWeAre />
      <HowItWorks />
    </>
  );
}
